define('RTC.Shopping', [
    'RTC.Cart.View'
], function RTCShopping(
    RTCCartView
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layoutComponent = container.getComponent('Layout');

            layoutComponent.addChildView('Cart.Summary', function rtcCartSummaryView() {
                return new RTCCartView();
            });
        }
    };
});

